<div class="help-menu">
  <div class="help-menu__header">
    <h2 class="help-menu__title" mat-dialog-title>How can we help?</h2>
    <sqep-dialog-close-button (close)="close()" />
  </div>

  <div class="help-menu__context">
    <p class="help-menu__context-text">{{ data.pageContext }}</p>
  </div>

  <button
    class="help-menu__row"
    type="button"
    [attr.aria-label]="'Open ' + data.guideName + ' user guide in new tab'"
    (click)="openGuide()"
  >
    <span class="help-menu__row-main">
      <span class="help-menu__eyebrow">Help for this page</span>
      <span class="help-menu__row-label">
        User Guide:
        <span class="help-menu__accent">{{ data.guideName }}</span>
      </span>
    </span>
    <mat-icon class="help-menu__row-icon" [svgIcon]="'open_in_new'" aria-hidden="true" />
  </button>

  <button
    class="help-menu__row"
    type="button"
    aria-label="Open what's new"
    aria-describedby="whats-new-desc"
    matTooltip="Keep up to date with any new releases as these will be sent via email monthly, alternatively you can check this quick option for any new enhancements added on each page."
    (click)="openWhatsNew()"
  >
    <span class="help-menu__row-label help-menu__row-label--inline">
      What's New?
      <mat-icon class="help-menu__info" [svgIcon]="'info'" aria-hidden="true" />
    </span>
    <mat-icon class="help-menu__row-icon" [svgIcon]="'menu_book'" aria-hidden="true" />
  </button>
  <span id="whats-new-desc" class="sr-only">
    Keep up to date with any new releases as these will be sent via email monthly, alternatively you can check this quick option for any new enhancements added on each page.
  </span>

  <!--
   Will come back to this later
    <div class="help-menu__footer">
    <span class="help-menu__row-label">
      Need more help?
      <a target="_blank" [href]="data.supportUrl">Contact the support desk </a>
    </span>
  </div> -->
</div>
